import * as React from "react";
const SvgLink = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#082B60"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m12.272 9.263.76-.76a3.925 3.925 0 0 0 0-5.534 3.925 3.925 0 0 0-5.535 0l-.76.76M3.725 6.742l-.755.755a3.92 3.92 0 0 0 0 5.534 3.925 3.925 0 0 0 5.534 0l.755-.755m-3.27-2.264 4.025-4.024"
    />
  </svg>
);
export default SvgLink;
